export enum UserType {
  NORMAL = 'NORMAL',
  PROUSER = 'PROUSER',
  DESIGNUSER = 'DESIGNUSER',
}
